import { c as _c } from "react/compiler-runtime";
import { ReactNode } from 'react';
import Box, { BoxProps } from '@classify/react-core-components/Box';
import { SxProps, Theme } from '@classify/react-core-components/styles';
export enum MediaFormats {
  isSquare = 'isSquare',
  isVideo = 'isVideo',
  isFourThirds = 'isFourThirds',
}
export interface Props extends BoxProps {
  children: ReactNode;
  format?: MediaFormats;
  sx?: SxProps<Theme>;
}
const NarrativeMediaContainer = t0 => {
  const $ = _c(16);
  const {
    format,
    children,
    sx
  } = t0;
  let style;
  let wrapperStyle;
  bb0: switch (format) {
    case MediaFormats.isSquare:
      {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = {
            width: {
              xs: 252,
              sm: 368,
              md: 360,
              lg: 416
            },
            "&, > :first-of-type": {
              maxWidth: "100%",
              display: "block",
              marginRight: "auto",
              marginLeft: "auto",
              height: "auto"
            }
          };
          $[0] = t1;
        } else {
          t1 = $[0];
        }
        style = t1;
        break bb0;
      }
    case MediaFormats.isVideo:
      {
        let t1;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = {
            xs: 336,
            sm: 704,
            md: 400,
            lg: 480
          };
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        let t2;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = {
            width: t1,
            position: "relative",
            paddingTop: "56.41%",
            height: 0,
            "& > iframe:first-of-type, & > video:first-of-type": {
              border: 0,
              position: "absolute",
              objectFit: "contain",
              width: "100%",
              height: "100%",
              top: 0,
              left: 0
            }
          };
          $[2] = t2;
        } else {
          t2 = $[2];
        }
        wrapperStyle = t2;
        let t3;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = {
            width: {
              xs: 336,
              sm: 704,
              md: 400,
              lg: 480
            }
          };
          $[3] = t3;
        } else {
          t3 = $[3];
        }
        style = t3;
        break bb0;
      }
    case MediaFormats.isFourThirds:
    default:
      {
        let t1;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = {
            width: {
              xs: 328,
              sm: 368,
              md: 400,
              lg: 384
            },
            "&, > :first-of-type": {
              maxWidth: "100%",
              display: "block",
              marginRight: "auto",
              marginLeft: "auto",
              height: "auto"
            }
          };
          $[4] = t1;
        } else {
          t1 = $[4];
        }
        style = t1;
      }
  }
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      alignSelf: "flex-start"
    };
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== style || $[7] !== sx) {
    t2 = {
      ...t1,
      ...style,
      ...sx
    };
    $[6] = style;
    $[7] = sx;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== children || $[10] !== format || $[11] !== wrapperStyle) {
    t3 = format === MediaFormats.isVideo ? <Box data-testid="narrative-media-container-video-inner-wrapper" sx={wrapperStyle}>{children}</Box> : children;
    $[9] = children;
    $[10] = format;
    $[11] = wrapperStyle;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t2 || $[14] !== t3) {
    t4 = <Box data-testid="narrative-media-container-root" sx={t2}>{t3}</Box>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};
export default NarrativeMediaContainer;